import { Image, Info } from 'components';

export default function GoalInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person climbing steps to plant flag at top" path="goal.png" title="Goal" />
        <h5>Goal</h5>
        <p>
            The <span className="fst-italic">Goal</span> is how you will judge the <span className="fst-italic">Results</span>. If you are testing against a benchmark or comparing two or more results, the <span className="fst-italic">Goal</span> is whether the winner should be a higher or lower value.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If you are testing two versions of a photo and you want to know which one gets more &quot;thumbs ups&quot;, then the winner should be the higher value.
            <br/>
            <br/>
            If you want to know the worst movie of all time, you need to find the lowest value.
        </p>
    </Info>;

}